import { AlertCircle, Clock } from 'lucide-react';
import { RateLimitError } from '@/lib/errors';

interface RateLimitErrorProps {
  error: RateLimitError;
  onDismiss?: () => void;
}

export function RateLimitErrorDisplay({ error, onDismiss }: RateLimitErrorProps) {
  return (
    <div className="card-simple border-error-500 bg-error-50">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <AlertCircle className="text-error-600" size={24} />
        </div>
        <div className="flex-grow">
          <h3 className="text-lg font-semibold text-error-900 mb-2">
            Daily Limit Reached
          </h3>
          <p className="text-error-700 mb-4">
            You've reached the daily limit for free productivity reports. This helps us keep the
            tool free and available for everyone.
          </p>
          <div className="flex items-center gap-2 text-error-600 mb-4">
            <Clock size={20} />
            <span className="font-medium">
              Try again in {error.getRetryTimeString()}
            </span>
          </div>
          <div className="bg-white rounded-lg p-4 border border-error-200">
            <p className="text-sm text-gray-700 mb-3">
              <strong>Want unlimited access?</strong> Create a My Best Day account for:
            </p>
            <ul className="space-y-2 text-sm text-gray-600 mb-4">
              <li className="flex items-start gap-2">
                <span className="text-primary-600 font-bold">✓</span>
                <span>Unlimited productivity reports</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary-600 font-bold">✓</span>
                <span>AI-powered daily intentions</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary-600 font-bold">✓</span>
                <span>Goal tracking and progress monitoring</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary-600 font-bold">✓</span>
                <span>Free tier available forever</span>
              </li>
            </ul>
            <a
              href="https://app.mybestday.ai"
              className="btn-primary w-full text-center"
            >
              Create Free Account
            </a>
          </div>
        </div>
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="mt-4 text-sm text-error-600 hover:text-error-700 font-medium"
        >
          Dismiss
        </button>
      )}
    </div>
  );
}
